import { useEffect, useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useDashboard = () => {
  const { token } = useAuth();

  const [myEvents, setMyEvents] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${apiRoot}/events/mine`, {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setMyEvents(json);
            setError(false);
          });
        } else {
          setError(true);
          setMyEvents(null);
        }
      })
      .catch((err) => {
        setError(true);
        setMyEvents(null);
      });
  }, [token]);

  return {
    myEvents,
    error,
  };
};

export default useDashboard;
